import { render } from "./PantryUsedUpEmptyView.vue?vue&type=template&id=a958db9a&ts=true"
import script from "./PantryUsedUpEmptyView.vue?vue&type=script&lang=ts"
export * from "./PantryUsedUpEmptyView.vue?vue&type=script&lang=ts"

import "./PantryUsedUpEmptyView.vue?vue&type=style&index=0&id=a958db9a&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__